<template>
	<div class="formWrap" >
		<div class="form-box mainCont">
			<div v-if="closeFlag" @click.stop="closeFun()" class="closeIcon"><i class="iconfont icon-cuo"></i></div>
			<h2>免费预约</h2>
			<el-form :model="form" id="reserForm" :rules="rules" ref="reserForm" class="formBox">
				<el-form-item class="form_item w48" prop="fwfl">
					<p class="laben">服务分类</p>
					<div class="item_input">
						<el-cascader :key="isResouceShow"
						v-model="serverVal" 
						:options="serverList" :props="{value:'id',label:'typeName'}"
						@change="handleChangeServer"></el-cascader>
						
					</div>
				</el-form-item>
				<el-form-item class="form_item w48" prop="productId">
					<p class="laben">服务产品</p>
					<div class="item_input">
						<el-select no-data-text="请先选择服务分类" v-model="form.productId" placeholder="请选择服务分类" :popper-append-to-body="false">
							<el-option
							  v-for="item in list"
							  :key="item.id"
							  :label="item.productName"
							  :value="item.id">
							</el-option>
						</el-select>
					</div>
				</el-form-item>
				<el-form-item class="form_item w48" prop="memberYysj">
					<p class="laben">预约时间</p>
					<div class="item_input">
						<el-date-picker @change="changeDate"  value-format="yyyy-MM-dd"  format="yyyy-MM-dd" v-model="form.memberYysj" type="datetime" placeholder="请选择时间">
					  </el-date-picker>
					  <el-select no-data-text="请先选择预约时间" v-model="form.time" placeholder="请选择时间段" :popper-append-to-body="false" style="margin-left: 5px;">
							<el-option
							v-for="item in arrayTime"
							:key="item.h"
							:label="item.val"
							:value="item.val">
							</el-option>
						</el-select>
					</div>
				</el-form-item>
				<el-form-item class="form_item w48" prop="province">
					<p class="laben">省市区</p>
					<div class="item_input">
						<!-- <el-cascader
						:options="optionsThree"
						v-model="selectedThree"
						placeholder="省市区三级联动"
						@change="handleChange"
						ref="three"
						></el-cascader> -->
						<el-cascader
						v-model="selectedThree"
						:options="options"
						:props="Props" 
						:key="cascaderKey"
						placeholder="请选择省市区" 
						@change="handleChange"
						ref="three"
						></el-cascader>
					</div>
				</el-form-item>
				<el-form-item class="form_item w48" prop="lxdz">
					<p class="laben">详细地址</p>
					<div class="item_input">
						<el-input v-model="form.lxdz" placeholder="请输入详细地址"></el-input>
					</div>
				</el-form-item>
				<el-form-item class="form_item w48" prop="content">
					<p class="laben">问题描述</p>
					<div class="item_input">
						<el-input v-model="form.content" placeholder="请输入问题描述"></el-input>
					</div>
				</el-form-item>
				
				<el-form-item class="form_item w48" prop="mobile">
					<p class="laben">手机号</p>
					<div class="item_input">
						<el-input style="flex: 1;" v-model="form.mobile" type="number" placeholder="请输入手机号"></el-input>
					</div>
				</el-form-item>
				<el-form-item class="form_item w48" prop="msgCode">
					<p class="laben">验证码</p>
					<div class="item_input">
						<el-input v-model="form.msgCode" placeholder="请输入验证码"></el-input>
						<div class="btn" @click="getVCode()">{{vcodeBtnName}}</div>
						<!-- <button class="btn" @click="getVCode()">{{vcodeBtnName}}</button> -->
					</div>
				</el-form-item>
				<el-form-item class="form_item">
					<p class="laben">备注</p>
					<div class="item_input">
						<el-input v-model="form.beizhu" type="textarea" :rows="4" resize="none" placeholder="请输入备注"></el-input>
					</div>
				</el-form-item>
			</el-form>
			<el-button type="primary" class="form_btn" @click="submitForm('reserForm')">提交</el-button>
		</div>
	</div>
</template>

<script>
import {orderCreate,getProductTypeAllList,getProductList,sendMsgCode,getProvicneCityArea} from '@/api/api'
import { provinceAndCityData, regionData} from "element-china-area-data";
export default {
	name: 'reserForm',
	props:{
		closeFlag:{
			type:Boolean,
			default:false
		},
		obj:{
			type:Object,
			default:()=>{
				return {}
			}
		},
	},
	watch:{
		obj:{
			handler(newName, oldName){
				console.log(newName);
			},
			deep: true,
    		immediate: true
		}
	},
	data() {
		const validateDate = (rule, value, callback) => {
			if (value) {
				// console.log(value)
				let choosetamp = new Date(value).getTime()// 选择的时间戳
				let timestamp = new Date().getTime()// 当前的时间戳
				timestamp = timestamp + 2 * 60 * 60 * 1000
				if (choosetamp < timestamp) {
					callback(new Error('请选择当前时间2个小时之后的时间'))
				} else {
					callback()
				}
				} else {
				callback()
			}
		}
		return {
			serverList: [],//服务分类
			serverVal: [],
			isResouceShow:0,
			list:[],//服务产品
			// 省市区级联
			optionsThree: regionData,
			optionsTwo: provinceAndCityData,
			selectedThree: [],
			selectedTwo: [],
			cascaderKey:1,
			options:[],
			Props: {
				lazy: true,
				// checkStrictly: true,
				lazyLoad: (node, resolve) => {
					console.log(node, 'node');
					let { value = 0 } = node;
					const nodes = [];
					getProvicneCityArea({parentId:value}).then(res => {
						console.log(res)
						let list = res.data;
						list.map((item) => {
							let obj = {
								value: item.id,
								label: item.typeName,
								leaf: node.level >=2,
							};
							nodes.push(obj)
						
						});
						resolve(nodes);
					})
				},
			},
			form:{
				"time":'',
				"area": "",//区
				"beizhu": "",//备注
				"city": "",//市
				"areaId": "",//区
				"cityId": "",//市
				"provinceId": "",//省
				"content": "",//描述
				"fwfl": "",//服务分类ID
				"fwflInfo": "",//服务分类
				// "img": "",//图片描述
				"lat": "34.74827",//纬度
				"lng": "113.612984",//经度
				"lxdz": "",//联系地址
				"lxrMobile": "",//联系人电话
				"lxrName": "",//联系人名称
				"memberYysj": "",//用户预约时间
				"mobile": "",//报修电话
				"msgCode": "",//验证码
				"msgId": "",//消息ID
				"name": "",//报修人名称
				"productId": "",//产品ID
				"province": "",//省
			},
			rules: {
				fwfl:[
					{ required: true, message: '请选择', trigger: 'blur' },
				],
				productId:[
					{ required: true, message: '请选择', trigger: 'blur' },
				],
				memberYysj: [
					{ required: true, message: '请选择预约时间', trigger: 'blur' },
					// { validator: validateDate, trigger: 'change' }
				],
				province: [
					{ required: true, message: '请选择', trigger: 'blur' },
				],
				mobile: [
					{ required: true, message: '请输入报修电话', trigger: 'blur' },
				],
				lxdz: [
					{ required: true, message: '请输入详情地址', trigger: 'blur' },
				],
				msgCode: [
					{ required: true, message: '请输入验证码', trigger: 'blur' },
				],
				content: [
					{ required: true, message: '请输入', trigger: 'blur' },
				],
			},
			vcodeBtnName:'获取验证码',
			countNum : 120,
			countDownTimer : null,
			arrayTime:[],
		};
	},
	mounted() {
		this.getProductTypeList();
		this.pTime();
	},
	methods: {
		//分类列表
		getProductTypeList(){
			getProductTypeAllList({flType:1,}).then(res => {
				console.log(res)
				let list = res.data;
				list.forEach(ele=>{
					ele.children.forEach(item=>{
						delete item.children
					})
				})
				this.serverList = list;
				this.isResouceShow = '665'
				if(this.obj.idsPath){//产品进入时默认分类
					let ids = this.obj.idsPath.split(',')
					this.serverVal = ids;
					this.form.fwfl = ids[1];
					getProductList({pageIndex: 1,pageSize: 100,productTypeId: ids[1]}).then(res => {
						console.log(res)
						let list = res.data;
						this.list = list;
						list.forEach((ele,i)=>{
							if(this.obj.id==ele.id){
								this.form.productId = ele.id
							}
						})
					})
				}
			})
		},
		// 服务分类---选择
		handleChangeServer(e){
			console.log(e)
			this.form.fwfl = e[1];
			let productTypeId = e[1];
			getProductList({pageIndex: 1,pageSize: 100,productTypeId: productTypeId}).then(res => {
				console.log(res)
				let list = res.data;
				this.list = list;
			})

		},
		 /**省市区三级联动 */
		 handleChange() {
			console.log(this.selectedThree);
			// console.log(this.$refs.three.getCheckedNodes()[0]);
			let arr = this.$refs.three.getCheckedNodes()[0].pathLabels
			this.form.province = arr[0];
			this.form.city = arr[1];
			this.form.area = arr[2];
			this.form.provinceId = this.selectedThree[0];
			this.form.cityId = this.selectedThree[1];
			this.form.areaId = this.selectedThree[2];
			
		},
		// 获取验证码
		getVCode(){
			var myreg=/^[1][0-9]{10}$/;
			if (!myreg.test(this.form.mobile)){
				this.$message({
				message: '请正确填写手机号码',
				type: 'warning'
				});
				return false;
			}
			// 手机号码为 :  this.phoneno
			// vcodeBtnName 可以阻止按钮被多次点击 多次发送 return 会终止函数继续运行
			if (this.vcodeBtnName != '获取验证码' && this.vcodeBtnName != '重新发送'){return ;}
			this.vcodeBtnName =  "发送中...";
			// 倒计时
			this.countNum = 60;
			this.countDownTimer = setInterval(function(){this.countDown();}.bind(this), 1000);
			// 与后端 api 交互，发送验证码
			const loading = this.$loading({
			lock: true,
			text: 'Loading',
			spinner: 'el-icon-loading',
			background: 'rgba(0, 0, 0, 0.7)'
			});
			sendMsgCode({mobile:this.form.mobile}).then(res => {
				loading.close();
				console.log(res)
				if(res.flag){
					this.form.msgId = res.data;
					this.$message(res.msg|| '短信已发送，请注意查收');
					// this.code = res.result
				}else{
					clearInterval(this.countDownTimer);
					this.$message(res.msg);
					this.vcodeBtnName =  "重新发送";
				}
				
			})
		},
		changeDate(value){
			console.log(value)
			let choosetamp = new Date(value).getTime()// 选择的时间戳
			let timestamp = new Date().getTime()// 当前的时间戳
			if(choosetamp>timestamp){
				this.pTime2();
			}else{
				this.pTime();
			}
		},
		// 选择时间 == 当前日期
		pTime(){
			let h = new Date().getHours();
			this.arrayTime = this.getArrayTime(h);
		},
		// 选择时间大于当前日期
		pTime2(){
			this.arrayTime = this.getArrayTime(0);
		},
		getArrayTime(h){
			console.log('444::',h)
			let arrayTime = [{h:1,val:'00:00-01:00'},{h:2,val:'01:00-02:00'},{h:3,val:'02:00-03:00'},{h:4,val:'03:00-04:00'},{h:5,val:'04:00-05:00'},{h:6,val:'05:00-06:00'},
			{h:7,val:'06:00-07:00'},{h:8,val:'07:00-08:00'},{h:9,val:'08:00-09:00'},{h:10,val:'09:00-10:00'},{h:11,val:'10:00-11:00'},{h:12,val:'11:00-12:00'},{h:13,val:'12:00-13:00'},
			{h:14,val:'13:00-14:00'},{h:15,val:'14:00-15:00'},{h:16,val:'15:00-16:00'},{h:17,val:'16:00-17:00'},{h:18,val:'17:00-18:00'},{h:19,val:'18:00-19:00'},{h:20,val:'19:00-20:00'},
			{h:21,val:'20:00-21:00'},{h:22,val:'21:00-22:00'},{h:23,val:'22:00-23:00'},{h:24,val:'23:00-24:00'}
			];
			let arr = []
			arrayTime.forEach(ele=>{
				if(ele.h>h){
					arr.push(ele)
				}
			})
			return arr
		},
		// 倒计时
		countDown(){
			if (this.countNum < 1){
				clearInterval(this.countDownTimer);
				this.vcodeBtnName = "重新发送";
				return ;
			}
			this.countNum--;
			this.vcodeBtnName =  this.countNum + '秒重发';
		},
		submitForm(formName) {
			// console.log({...this.form})
			// return false
			this.$refs[formName].validate((valid) => {
				if (valid) {
					// lxrName 姓名
					let formData = {...this.form}
					formData.lxrMobile = formData.mobile;
					console.log(this.form)
					formData.memberYysj = formData.memberYysj +' '+ formData.time; 
					formData.lxrName = 'PC';
					formData.name = "PC";
					// return false
					orderCreate(formData).then(res => {
						if(res.flag){
							this.$message({
								message: res.msg,
								type: 'success'
							});
							this.closeFun();
							this.vcodeBtnName = '获取验证码';
							this.countNum =  120;
							this.countDownTimer = null;
							this.form = {
								"time":'',
								"area": "",//区
								"beizhu": "",//备注
								"city": "",//市
								"areaId": "",//区
								"cityId": "",//市
								"provinceId": "",//省
								"content": "",//描述
								"fwfl": "",//服务分类ID
								"fwflInfo": "",//服务分类
								// "img": "",//图片描述
								"lat": "34.74827",//纬度
								"lng": "113.612984",//经度
								"lxdz": "",//联系地址
								"lxrMobile": "",//联系人电话
								"lxrName": "",//联系人名称
								"memberYysj": "",//用户预约时间
								"mobile": "",//报修电话
								"msgCode": "",//验证码
								"msgId": "",//消息ID
								"name": "",//报修人名称
								"productId": "",//产品ID
								"province": "",//省
							};
						}else{
							this.$message(res.msg);
						}
						
					})
				}
			});
		},
		closeFun(){
			this.$emit('closeBtn')
		},
	},
};
</script>

<style lang="scss">
.formWrap{position: relative;
	.form-box{width: 1012px;min-height: 698px;background: #FFFFFF;border-radius: 20px;padding: 40px 66px 48px;margin: 26px auto 44px;position: relative;
		.closeIcon{position: absolute;top: 30px;right: 30px;color: #A4A9B7;
			i{font-size: 26px;cursor: pointer;transition: all .3s;
				&:hover{color: red;}
			}
		}
		h2{color: #292A2C;font-size: 30px;font-weight: bold;margin-bottom: 30px;}
		.formBox{display: flex;align-items: center;flex-wrap: wrap;justify-content: space-between;
			.form_item{width: 100%;margin-bottom: 24px;
				&.w48{width: 48.86%;}
				.laben{color: #1F263F;font-size: 14px;margin-bottom: 8px;}
				.item_input{position: relative;width: 100%;display: flex;align-items: center;
					.el-select,.el-input{width: 100%;border-radius: 10px;
						.el-input__inner{border-radius: 5px;height: 50px;line-height: 50px;}
					}
					.el-date-editor{width: 100%;border-radius: 10px;
						.el-input__inner{border-radius: 5px;height: 50px;line-height: 50px;}
					}
					.el-cascader{width: 100%;
						.el-input__inner{border-radius: 5px;height: 50px;line-height: 50px;}
					}
					.btn{width: 102px;height: 50px;text-align: center;line-height: 50px;background: #2F78FF;border-radius: 5px;padding: 0;border: 0;color:#fff;font-size: 14px;margin-left: 8px;cursor: pointer;}
				}
				.item_inputs{position: relative;display: flex;align-items: center;justify-content: space-between;
					.el-select{width: 170px;
						.el-input__inner{border-radius: 5px;height: 50px;line-height: 50px;}
					}
				}
			}
		}
		.form_btn{width: 350px;height: 60px;background: #2F78FF;border-radius: 5px;padding: 0;border: 0;color:#fff;font-size: 16px;margin: 24px auto 0;cursor: pointer;display: block;}
	}
}
</style>



// WEBPACK FOOTER //
// src/views/reservation/components/formSend.vue